
import { useState } from "react";
import styles from "../../FieldTypeModal.module.scss";

type Props = {
    onChange: (val: string) => void
    filedLabel: string
    placeholederText: string
    value: string
    onClear: () => void
    multiple?:boolean
}

export const InputWithClearFiledConfig = (props: Props) => {
    
    const [isFocused, setIsFocused] = useState(false);

    return  <div className={styles.configurationField}>
                <div className={styles.title}>
                    <span className={styles.label}>{props.filedLabel}</span>
                </div>
                <div className={styles.body}>
                    <div className={styles.inputWithClear}>
                        {props.multiple ?
                        <textarea
                            value={props.value}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            onChange={(e) =>
                                props.onChange(e.target.value.trim())
                            }
                            placeholder={isFocused || props.value ? "" : props.placeholederText}
                            rows={4}
                            className={styles.textarea}
                        />:
                        <input
                            type="text"
                            value={props.value}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            onChange={(e) =>
                                props.onChange(e.target.value.trim())
                            }
                            placeholder={isFocused || props.value ? "" : props.placeholederText}
                            
                        />
                        }
                        <button className={styles.clearBtn} onClick={props.onClear}>
                            {props.value &&
                                <span>×</span>
                            }
                        </button>
                    </div>
                </div>
            </div>
}